export const orderActionTypes = {
  getUnapprovedOrders: '[Orders] get unapproved orders async',
  getMyOrders: '[Orders] get my orders async',
  getAllOrders: '[Orders] get all orders async',
  hideCancelConfirmation: '[Orders] hide cancel confirmation',
  cancelStepStatusChangeAllOrders:
    '[Orders] cancel step status change allOrders',
  declineOrder: '[Orders] decline order async',
  approveOrder: '[Orders] approve order async',

  openDeclineDialog: '[Orders] open decline dialog',
  closeDeclineDialog: '[Orders] close decline dialog',
  clearDeclinedConfirmation: '[Orders] clear declined confirmation',

  closeApproveDialog: '[Orders] close approve dialog',
};
